/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
//window.APIURL = 'http://ctr.test/api/fileservice';
//window.APIURL = 'https://app.chiptuningreseller.com/api/fileservice';

window.axios = require('axios');

if(typeof(SITEKEY) === 'undefined') {
    alert('Warning: the communication key has not been properly set-up. Cannot continue.');
} else {
    axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
    axios.defaults.headers["CTR-Access-Key"] = SITEKEY;
    axios.defaults.headers["Cache-Control"] = "max-age=1440";
    axios.defaults.params = {};
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery');
    require('bootstrap');
} catch (e) {}




// WEBPACK FOOTER //
// ./src/assets/bootstrap.js